import { combineReducers } from 'redux';

import { whiteMailReducer } from '@s/white-mail/slice';

import { applicationReducer } from './application';
import { audienceReducer } from './audience-builder';
import { dashboardReducer } from './dashboard';
import { userReducer } from './user';

const rootReducer = combineReducers({
  application: applicationReducer,
  audience: audienceReducer,
  dashboard: dashboardReducer,
  user: userReducer,
  whiteMail: whiteMailReducer,
});

export default rootReducer;
